import { canMaintenanceReload, installPlannedMaintenance } from "../libs/planned-maintenance";
import "./maintenance.css";

// O meta é o marcador de que o layout renderizou o cliente (e o estado) nesta página; não existe
// mais flag de servidor para ligar o gate.
if (document.querySelector('meta[name="planned-maintenance-enabled"][content="1"]')) {
  const logoUrl = document.querySelector<HTMLMetaElement>('meta[name="planned-maintenance-logo"]')?.content ?? null;
  const controller = installPlannedMaintenance({ logoUrl });
  Object.assign(window, { hospedinCanMaintenanceReload: canMaintenanceReload });
  const hot = (import.meta as ImportMeta & { hot?: { dispose: (cleanup: () => void) => void } }).hot;
  hot?.dispose(controller.cleanup);
}
